// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wp-0";
export var confirmationIcon = "_wp-1";